import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  DELAY_FILTER_TIME,
} from "constants/RemoteDataTableContanst";
import {
  CheckActionAccessList,
  convertDateTime,
  formatDateTime,
} from "helpers/utils";
import { useHubList, useUpdateHub } from "hooks/hub-management/useHub";
import React, { useEffect, useMemo, useState } from "react";
import { customFilter, textFilter } from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { Link, useNavigate } from "react-router-dom";
import { Badge, Card, CardBody, Col, Row, Label } from "reactstrap";
import BreadcrumbWithLink from "../../components/Common/BreadcrumbWithLink";
import SearchGroup from "./SearchGroup";
import DetailHub from "./detailHub";
import { Switch } from "antd";

const HubManagement = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(["hub"]);
  // const [is_level_2, setIsLevel2] = useState(true);

  const [hubListParams, setHubListParams] = useState({
    page: 1,
    sizePerPage: 10,
    expand: "checker,parent_hub",
    columnFilter: {
      // "filter[is_new_address]": "N",
    },
    parent_hub_name: undefined,
  });

  const [isOpenConfirmActiveModal, setIsOpenConfirmActiveModal] =
    useState(false);
  const [hubChoosen, setHubChoosen] = useState(null);
  const [isOpenDetail, setIsOpenDetail] = useState(false);
  const [hubDetailId, setHubDetailId] = useState(null);

  // const handleChangeIsLevel2 = value => {
  //   setIsLevel2(value);
  //   setHubListParams(prev => ({
  //     ...prev,
  //     columnFilter: {
  //       ...prev.columnFilter,
  //       "filter[is_new_address]": value ? "N" : "O",
  //     },
  //     page: 1,
  //   }));
  // };

  const columnTable = [
    {
      dataField: "id",
      text: t("table.no"),
      formatter: (cell, row, enumObject) => {
        return `${enumObject + 1}`;
      },
    },
    {
      dataField: "hub_order_code",
      text: t("table.id"),
      sort: true,
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.id"),
        }),
      }),
    },
    {
      dataField: "name",
      text: t("table.name"),
      sort: true,
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.name"),
        }),
      }),
    },
    {
      dataField: "parent_hub_id",
      text: t("table.parent_hub"),
      sort: true,
      formatter: (_cell, row) => {
        return row?.parent_hub?.name;
      },
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.parent_hub"),
        }),
      }),
    },
    {
      dataField: "address",
      text: t("table.address"),
      sort: true,
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.address"),
        }),
      }),
    },
    {
      dataField: "checker_date",
      text: t("table.updated_date"),
      sort: true,
      formatter: (cell, row) => {
        if (cell) {
          return convertDateTime(cell, formatDateTime.DD_MM_YYYY_hh_mm_ss);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={hubListParams.columnFilter}
        />
      ),
    },
    {
      dataField: "checker_id",
      text: t("table.updater"),
      sort: true,
      formatter: (_cell, row) => {
        return row.checker?.display_name;
      },
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.updater"),
        }),
      }),
    },
    {
      dataField: "record_status",
      text: t("table.status"),
      sort: true,
      align: "center",
      formatter: (cell, row) => {
        if (cell === "O") {
          return (
            <Badge color="success" pill>
              {t("actions.active")}
            </Badge>
          );
        } else {
          return (
            <Badge color="danger" pill>
              {t("actions.un_active")}
            </Badge>
          );
        }
      },
    },
    {
      dataField: "is_center",
      text: t("table.center"),
      align: "center",
      sort: true,
      formatter: (cell, row) => {
        if (cell === 1) {
          return <i className="fas fa-check-circle text-success"></i>;
        }
      },
    },
  ];

  const listRowAction = [
    {
      actionAccess: "",
      icon: <i className="fas fa-pen fa-lg text-primary ms-2" />,
      text: t("actions.edit"),
      onClick: row => {
        navigate(`/hub/${row.id}`);
      },
    },
    {
      actionAccess: "",
      icon: <i className="fas fa-lock fa-lg ms-2 text-danger" />,
      text: t("actions.un_active"),
      conditionVisible: {
        record_status: ["O"],
      },
      onClick: row => handleActiveAction(row.id, "unActive"),
    },
    {
      actionAccess: "",
      icon: <i className="fas fa-unlock fa-lg ms-2 text-success" />,
      text: t("actions.active"),
      conditionVisible: {
        record_status: ["C"],
      },
      onClick: row => handleActiveAction(row.id, "active"),
    },
  ];

  const {
    isLoading,
    data: hubList,
    refetch: refetchHubList,
  } = useHubList({ params: hubListParams });

  const dataTableHubList = useMemo(() => {
    if (hubList?.items && hubList.items.length > 0) return hubList.items;
    return [];
  }, [hubList]);

  useEffect(() => {
    refetchHubList();
  }, [hubListParams]);

  const onTableChange = (_type, value) => {
    const column_filter = value.columnFilter;
    const parent_hub_name = column_filter["filter[parent_hub_id][like]"];
    delete column_filter["filter[parent_hub_id][like]"];
    setHubListParams(prev => ({
      ...prev,
      page: value.page,
      sizePerPage: value.sizePerPage,
      sort: `${value.sortOrder}${value.sortField}`,
      columnFilter: {
        "filter[record_status]": prev.columnFilter["filter[record_status]"],
        "filter[is_center]": prev.columnFilter["filter[is_center]"],
        // "filter[is_new_address]": "N",
        // "filter[is_new_address]": is_level_2 ? "N" : "O",
        ...(column_filter || {}),
      },
      parent_hub_name: parent_hub_name,
    }));
  };

  const onSearchAllHandle = value => {
    setHubListParams(prev => ({
      ...prev,
      keywords: value,
    }));
  };

  const handleActiveAction = (hubId, action) => {
    setHubChoosen({
      id: hubId,
      action,
    });
    setIsOpenConfirmActiveModal(true);
  };

  const onSuccessUpdate = () => {
    setHubChoosen(null);
    setIsOpenConfirmActiveModal(false);
    refetchHubList();
  };

  const { mutate: updateHub } = useUpdateHub(onSuccessUpdate);

  const confirmActiveModal = () => {
    const payloadData = {
      record_status: hubChoosen?.action === "active" ? "O" : "C",
    };
    updateHub({
      hubId: hubChoosen?.id,
      data: payloadData,
    });
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {
      toggleDetailHub();
      setHubDetailId(row.id);
    },
  };

  const toggleDetailHub = () => {
    setIsOpenDetail(prev => !prev);
  };

  const rowActionList = CheckActionAccessList(listRowAction, "actionAccess");

  return (
    <div className="page-content">
      <MetaTags>
        <title>{t("title.manager")}</title>
      </MetaTags>
      <div className="container-fluid">
        <BreadcrumbWithLink
          title={
            t("title.list", { target: t("title.manager") }) +
            ` (${hubList?.totalCount})`
          }
          breadcrumbItems={[
            { name: t("title.manager") },
            { name: t("title.list", { target: t("hub") }) },
          ]}
        />
        <Row>
          <Col>
            <Card>
              <CardBody>
                <RemoteDataTable
                  keyField="id"
                  data={dataTableHubList || []}
                  columns={columnTable}
                  listRowAction={rowActionList}
                  loading={isLoading}
                  page={hubListParams.page}
                  onTableChange={onTableChange}
                  isShowRowIndex={false}
                  totalSize={hubList?.totalCount}
                  onSearchAllHandle={onSearchAllHandle}
                  rowEvents={rowEventsHandler}
                >
                  <div className="d-flex gap-2 align-items-center">
                    {/* <Label
                      className="d-flex align-items-center gap-1 mb-0"
                      style={{ cursor: "pointer" }}
                      htmlFor="is_level_2"
                      onClick={() => handleChangeIsLevel2(!is_level_2)}
                    >
                      <Switch
                        checked={is_level_2}
                        onChange={handleChangeIsLevel2}
                      />
                      Địa chỉ 2 cấp
                    </Label> */}

                    <div className="d-flex flex-column flex-sm-wrap flex-sm-row mb-md-0 align-items-baseline gap-2">
                      <SearchGroup
                        hubListParams={hubListParams}
                        setHubListParams={setHubListParams}
                      />
                    </div>

                    <div className="d-flex align-items-center">
                      <button
                        // onClick={() => navigate(`/hub/create?level=${is_level_2 ? '2' : '3'}`)}
                        //
                        onClick={() => navigate(`/hub/create?level=2`)}
                        className="btn btn-secondary btn-label"
                      >
                        <i className="fas fa-plus label-icon" />
                        {t("title.create")}
                      </button>
                    </div>
                  </div>
                </RemoteDataTable>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <ConfirmModal
        isOpen={isOpenConfirmActiveModal}
        titleHeader={
          hubChoosen?.action === "active"
            ? t("actions.confirmActiveModal.titleActive")
            : t("actions.confirmActiveModal.titleUnActive")
        }
        titleBody={
          hubChoosen?.action === "active"
            ? t("actions.confirmActiveModal.contentActive")
            : t("actions.confirmActiveModal.contentUnActive")
        }
        onConfirm={confirmActiveModal}
        textBtnConfirm={t("actions.confirmActiveModal.confirmBtn")}
        textBtnCancel={t("actions.confirmActiveModal.cancelBtn")}
        toggle={() => setIsOpenConfirmActiveModal(false)}
      />
      <DetailHub
        hubId={hubDetailId}
        toggleModal={toggleDetailHub}
        isOpenModal={isOpenDetail}
      />
    </div>
  );
};

export default HubManagement;
